import request from '@/utils/request'

export default {
  getList(page, size, keyword) {
    return request.get('/college/list', {
      params: { page, size, keyword }
    })
  },
  getCollegeList(page, size, keyword) {
    return request.get('/college/list', {
      params: { page, size, keyword }
    })
  },
  add(data) {
    return request.post('/college/add', data)
  },
  update(data) {
    return request.put('/college/update', data)
  },
  delete(id) {
    return request.delete(`/college/delete/${id}`)
  },
  batchDelete(ids) {
    return request.post('/college/batch-delete', ids)
  },
  upload(file) {
    const formData = new FormData()
    formData.append('file', file)
    return request.post('/college/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  importMajor(file) {
    const formData = new FormData()
    formData.append('file', file)
    return request.post('/college/import-major', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 600000 // 10分钟超时
    })
  }
}
